export default __webpack_public_path__ + "static/media/vivabonito5.323ef73b.jpg";